var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFolder = function SvgIconFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-672 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M687.571,181.286a1,1,0,0,1-1,1H685v1.571a1,1,0,1,1-2,0v-1.571h-1.571a1,1,0,0,1,0-2H683v-1.572a1,1,0,1,1,2,0v1.572h1.571A1,1,0,0,1,687.571,181.286ZM694,176.143v10.286a2.288,2.288,0,0,1-2.286,2.285H676.286A2.288,2.288,0,0,1,674,186.429V173.571a2.288,2.288,0,0,1,2.286-2.285h3.324a2.273,2.273,0,0,1,1.616.668l1.9,1.9h8.586A2.288,2.288,0,0,1,694,176.143Zm-2,0a.286.286,0,0,0-.286-.286h-9a1,1,0,0,1-.707-.293l-2.2-2.195a.284.284,0,0,0-.2-.083h-3.324a.286.286,0,0,0-.286.285v12.858a.286.286,0,0,0,.286.285h15.428a.286.286,0,0,0,.286-.285Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-folder.32f78001.svg";
export { ForwardRef as ReactComponent };